import ApiClient from '../schedule/api.es6';


export default class TopNews{

    constructor(){
        this.api = null;
        this.newsList = [];
        this._init();
    }


    _init(){
        this._setupNews();
    }


    _setupNews(){
        this._fetchNewsJson();
    }


    async _fetchNewsJson(){
        this.api = new ApiClient('./api/schedule.php');
        
        try{
            const json = await this.api.fetchData();
            this._parseJson(json);
            this._createNewsDom();
        }
        catch(e){
            console.error('Failed to fetch data:', e);
        }
    }


    _parseJson(json) {
        const createDataObject = (item) => {
            return {
                id: item.id,
                title: item.title_html,
                date: this.os === 'iOS' ? item.date : item.date.replace(/-/g, '.'),
                content: item.content_html,
            };
        };

        let hasMatch = false; 

        for (let i = 0; i < json.length; i++) {
            const data = createDataObject(json[i]);

            const tagRegex = /#tag:news/;
            const match = data.content.match(tagRegex);
            // TOPにはnewsのみ表示
            if (match) {
                hasMatch = true;
                this.newsList.push(data);
            }
        }

        if (!hasMatch) {
            for (let i = 0; i < json.length; i++) {
                const data = createDataObject(json[i]);
                this.newsList.push(data);
            }
        }

        // 最新の日付で並び替える
        this.newsList.sort((a, b) => {
            return new Date(b.date) - new Date(a.date);
        });
    }


    _createNewsDom(){
        const latest  = this.newsList[0];
        document.querySelector('.js-news-date').innerHTML = latest.date;
        document.querySelector('.js-news-title').innerHTML = latest.title;
    }
}
